import { ContractPriceStripTimeModel, Frequency } from '../types/all';
import { ContractOfferType } from '../types/contract-offer-type';
import { ContractPriceStripCurveType } from '../types/contract-price-strip-curve-type';
import { PriceStripSubCategory } from '../types/priceStrip-subCategory.enum';

import { Instrument } from './contract-formula-instrument.model';
import { PriceStripFormula } from './contract-formula.model';
import { ContractPerimeter } from './contract-perimeter.model';

/**
 * Model for API ContractPerimeterPriceStrip Model
 */
export class ContractPriceStrip {
  /**
   * Strip’s unique identifier.
   */
  id: number;

  /**
   * Strip’s name.
   */
  name: string;

  /**
   * Perimeter.
   */
  perimeter: ContractPerimeter;

  /**
   * Strip's formula legs
   */
  formulas: PriceStripFormula[];

  /**
   * Price strip's invoicing lower curve
   */
  invoicingLowerCurve: string;

  /**
   * Price strip's invoicing upper curve
   */
  invoicingUpperCurve: string;

  /**
   * Price strip's pricing lower curve
   */
  pricingLowerCurve: string;

  /**
   * Price strip's pricing upper curve
   */
  pricingUpperCurve: string;

  /**
   * Price strip's invoicing curves unit
   */
  invoicingCurvesUnit: string;

  /**
   * Price strip's pricing curves unit
   */
  pricingCurvesUnit: string;

  /**
   * Price strip's dispatching ref curve
   */
  dispatchingReferenceCurve: ContractPriceStripCurveType;

  /**
   * The time model of the price strip
   */
  timeModel: ContractPriceStripTimeModel;

  /**
   * Calculation frequency (10T, D, M, Y…)
   */
  calculationFrequency: Frequency;

  /**
   * Calculation frequency (10T, D, M, Y…)
   */
  fixationFrequency: Frequency;

  /**
   * Price Strip's instrument.
   */
  instruments: Instrument[];

  /**
   * Price strip’s category
   */
  subCategory: PriceStripSubCategory;

  /**
   * Transaction click type one of: ["% only", "volume and %", "MW"]
   */
  clickType: string;

  /**
   * Priceable
   */
  priceable: string;

  constructor(attributes: Partial<ContractPriceStrip> = {}) {
    Object.assign(this, attributes);
  }

  get isReceivingBrpDisplayed() {
    return (
      this.perimeter.offerType == ContractOfferType.hubBlocks &&
      [PriceStripSubCategory.internalPhysicalBlock, PriceStripSubCategory.injectionInternalPhisycalBlock].includes(this.subCategory)
    );
  }
}
